// extracted by mini-css-extract-plugin
export default {"container":"App_container__mn4nA","image":"App_image__4pwAm"};